import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Modal } from '@components/bootstrap';
const RoleModal = ({ show, mode, data, permissions, role, onClose, onSave, onDelete }) => {
    const [formData, setFormData] = useState(data);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        setFormData(data);
        setErrors({});
    }, [data]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };
    const handlePermissionChange = (permissionId, checked) => {
        setFormData(prev => ({
            ...prev,
            permissions: checked
                ? [...prev.permissions, permissionId]
                : prev.permissions.filter(id => id !== permissionId)
        }));
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = 'Nome do perfil é obrigatório';
        }
        if (formData.permissions.length === 0) {
            newErrors.permissions = 'Selecione pelo menos uma permissão';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (mode !== 'delete' && !validateForm()) {
            return;
        }
        if (mode === 'delete') {
            onDelete();
        }
        else {
            onSave(formData);
        }
    };
    const getModalTitle = () => {
        switch (mode) {
            case 'add': return 'Adicionar Perfil';
            case 'edit': return 'Editar Perfil';
            case 'delete': return 'Excluir Perfil';
            default: return '';
        }
    };
    const getModalContent = () => {
        if (mode === 'delete') {
            return (_jsxs("div", { className: "text-center", children: [_jsx("div", { className: "mb-4", children: _jsx("i", { className: "fas fa-exclamation-triangle text-warning", style: { fontSize: '3rem' } }) }), _jsx("h5", { children: "Tem certeza que deseja excluir este perfil?" }), _jsxs("p", { className: "text-muted", children: ["Esta a\u00E7\u00E3o n\u00E3o pode ser desfeita. O perfil ", _jsx("strong", { children: role?.name }), " ser\u00E1 removido permanentemente."] })] }));
        }
        return (_jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("div", { className: "mb-3", children: [_jsx("label", { className: "form-label", children: "Nome do Perfil" }), _jsx("input", { type: "text", name: "name", value: formData.name, onChange: handleInputChange, className: `form-control ${errors.name ? 'is-invalid' : ''}`, placeholder: "Digite o nome do perfil" }), errors.name && (_jsx("div", { className: "invalid-feedback", children: errors.name }))] }), _jsxs("div", { className: "mb-3", children: [_jsx("label", { className: "form-label", children: "Permiss\u00F5es" }), _jsx("div", { className: `permissions-container ${errors.permissions ? 'is-invalid' : ''}`, children: permissions.map((permission) => (_jsxs("div", { className: "form-check", children: [_jsx("input", { type: "checkbox", id: permission.id, checked: formData.permissions.includes(permission.id), onChange: (e) => handlePermissionChange(permission.id, e.target.checked), className: "form-check-input" }), _jsxs("label", { className: "form-check-label", htmlFor: permission.id, children: [_jsx("div", { className: "permission-name", children: permission.name }), _jsx("div", { className: "permission-description", children: permission.description })] })] }, permission.id))) }), errors.permissions && (_jsx("div", { className: "invalid-feedback", children: errors.permissions }))] })] }));
    };
    const getModalFooter = () => (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: "btn btn-secondary", onClick: onClose, children: "Cancelar" }), _jsx("button", { type: mode === 'delete' ? 'button' : 'submit', className: `btn ${mode === 'delete' ? 'btn-danger' : 'btn-primary'}`, onClick: handleSubmit, children: mode === 'delete' ? 'Excluir' : mode === 'add' ? 'Adicionar' : 'Salvar' })] }));
    return (_jsx(Modal, { show: show, onHide: onClose, title: getModalTitle(), size: "lg", footer: getModalFooter(), children: getModalContent() }));
};
export default RoleModal;
